import { render, staticRenderFns } from "./InviteEmails.vue?vue&type=template&id=40ffe69e&"
import script from "./InviteEmails.vue?vue&type=script&lang=js&"
export * from "./InviteEmails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports